import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  allUsers: [],
};

export const companySlice = createSlice({
  name: "company",
  initialState,
  reducers: {
    setAllUsers: (state, action) => {
      state.allUsers = action.payload;
    },
  },
});

export const { setAllUsers } = companySlice.actions;

export default companySlice.reducer;

